import {
  INIT_URL,
  FETCH_GATEWAY_TRANSACTION_START,
  FETCH_GATEWAY_TRANSACTION_SUCCESS,
  FETCH_GATEWAY_TRANSACTION_ERROR,
  FETCH_GATEWAY_TRANSACTIONS_START,
  FETCH_GATEWAY_TRANSACTIONS_SUCCESS,
  FETCH_GATEWAY_TRANSACTIONS_ERROR,
  FETCH_GATEWAY_CALLBACKS_START,
  FETCH_GATEWAY_CALLBACKS_SUCCESS,
  FETCH_GATEWAY_CALLBACKS_ERROR,
  FETCH_GATEWAY_SUSPICIOUS_LOGS_START,
  FETCH_GATEWAY_SUSPICIOUS_LOGS_SUCCESS,
  FETCH_GATEWAY_SUSPICIOUS_LOGS_ERROR,
  FETCH_GATEWAY_IPNS_START,
  FETCH_GATEWAY_IPNS_SUCCESS,
  FETCH_GATEWAY_IPNS_ERROR,
  FETCH_GATEWAY_IPN_START,
  FETCH_GATEWAY_IPN_SUCCESS,
  FETCH_GATEWAY_IPN_ERROR,
  CHANGE_PAGE_LIMIT,
  CHANGE_PAGE,
} from '../../constants/ActionTypes';

const INIT_STATE = {
  gateway_transactions: {
    data: [],
    loading: false,
    error: null,
    currentPage: 1,
    pageSize: 10,
    totalRecords: 1,
  },
  gateway_transaction: {
    data: null,
    loading: false,
    error: null,
  },
  gateway_callbacks: {
    data: [],
    loading: false,
    error: null,
    currentPage: 1,
    pageSize: 10,
    totalRecords: 1,
  },
  gateway_suspicious_logs: {
    data: [],
    loading: false,
    error: null,
    currentPage: 1,
    pageSize: 10,
    totalRecords: 1,
  },
  gateway_ipns: {
    data: [],
    loading: false,
    error: null,
    currentPage: 1,
    pageSize: 10,
    totalRecords: 1,
  },
  gateway_ipn: {
    data: null,
    loading: false,
    error: null,
  },
  gateway_account_limits: {
    data: [],
    loading: false,
    error: null,
    currentPage: 1,
    pageSize: 10,
    totalRecords: 1,
  },
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case CHANGE_PAGE_LIMIT: {
      return {
        ...state,
        [action.payload.type]: {
          ...state[action.payload.type],
          pageSize: action.payload.pageSize,
        },
      };
    }

    case CHANGE_PAGE: {
      return {
        ...state,
        [action.payload.type]: {
          ...state[action.payload.type],
          currentPage: action.payload.currentPage,
        },
      };
    }

    case INIT_URL: {
      return { ...state, initURL: action.payload };
    }

    case FETCH_GATEWAY_TRANSACTION_START: {
      return {
        ...state,
        gateway_transaction: {
          ...state.gateway_transaction,
          loading: true,
        },
      };
    }

    case FETCH_GATEWAY_TRANSACTION_SUCCESS: {
      return {
        ...state,
        gateway_transaction: {
          ...state.gateway_transaction,
          loading: false,
          data: action.payload,
        },
      };
    }

    case FETCH_GATEWAY_TRANSACTION_ERROR: {
      return {
        ...state,
        gateway_transaction: {
          ...state.gateway_transaction,
          loading: false,
          error: action.payload,
        },
      };
    }

    case FETCH_GATEWAY_TRANSACTIONS_START: {
      return {
        ...state,
        gateway_transactions: {
          ...state.gateway_transactions,
          loading: true,
        },
      };
    }

    case FETCH_GATEWAY_TRANSACTIONS_SUCCESS: {
      return {
        ...state,
        gateway_transactions: {
          ...state.gateway_transactions,
          loading: false,
          data: action.payload,
          currentPage: action.currentPage,
          totalRecords: action.totalRecords,
        },
      };
    }

    case FETCH_GATEWAY_TRANSACTIONS_ERROR: {
      return {
        ...state,
        gateway_transactions: {
          ...state.gateway_transactions,
          loading: false,
          error: action.payload,
        },
      };
    }
    case FETCH_GATEWAY_CALLBACKS_START: {
      return {
        ...state,
        gateway_callbacks: {
          ...state.gateway_callbacks,
          loading: true,
        },
      };
    }

    case FETCH_GATEWAY_CALLBACKS_SUCCESS: {
      return {
        ...state,
        gateway_callbacks: {
          ...state.gateway_callbacks,
          loading: false,
          data: action.payload,
          currentPage: action.currentPage,
          totalRecords: action.totalRecords,
        },
      };
    }

    case FETCH_GATEWAY_CALLBACKS_ERROR: {
      return {
        ...state,
        gateway_callbacks: {
          ...state.gateway_callbacks,
          loading: false,
          error: action.payload,
        },
      };
    }

    case FETCH_GATEWAY_SUSPICIOUS_LOGS_START: {
      return {
        ...state,
        gateway_suspicious_logs: {
          ...state.gateway_suspicious_logs,
          loading: true,
        },
      };
    }

    case FETCH_GATEWAY_SUSPICIOUS_LOGS_SUCCESS: {
      return {
        ...state,
        gateway_suspicious_logs: {
          ...state.gateway_suspicious_logs,
          loading: false,
          data: action.payload,
          currentPage: action.currentPage,
          totalRecords: action.totalRecords,
        },
      };
    }

    case FETCH_GATEWAY_SUSPICIOUS_LOGS_ERROR: {
      return {
        ...state,
        gateway_suspicious_logs: {
          ...state.gateway_suspicious_logs,
          loading: false,
          error: action.payload,
        },
      };
    }

    case FETCH_GATEWAY_IPNS_START: {
      return {
        ...state,
        gateway_ipns: {
          ...state.gateway_ipns,
          loading: true,
        },
      };
    }

    case FETCH_GATEWAY_IPNS_SUCCESS: {
      return {
        ...state,
        gateway_ipns: {
          ...state.gateway_ipns,
          loading: false,
          data: action.payload,
          currentPage: action.currentPage,
          totalRecords: action.totalRecords,
        },
      };
    }

    case FETCH_GATEWAY_IPNS_ERROR: {
      return {
        ...state,
        gateway_ipns: {
          ...state.gateway_ipns,
          loading: false,
          error: action.payload,
        },
      };
    }

    case FETCH_GATEWAY_IPN_START: {
      return {
        ...state,
        gateway_ipn: {
          ...state.gateway_ipn,
          loading: true,
        },
      };
    }

    case FETCH_GATEWAY_IPN_SUCCESS: {
      return {
        ...state,
        gateway_ipn: {
          ...state.gateway_ipn,
          loading: false,
          data: action.payload,
        },
      };
    }

    case FETCH_GATEWAY_IPN_ERROR: {
      return {
        ...state,
        gateway_ipn: {
          ...state.gateway_ipn,
          loading: false,
          error: action.payload,
        },
      };
    }

    default:
      return state;
  }
};
